import { render } from "./ProductsManager.vue?vue&type=template&id=8d0ad8fc&scoped=true"
import script from "./ProductsManager.vue?vue&type=script&lang=js"
export * from "./ProductsManager.vue?vue&type=script&lang=js"

import "./ProductsManager.vue?vue&type=style&index=0&id=8d0ad8fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0ad8fc"]])

export default __exports__